export default __webpack_public_path__ + "static/media/PowerPoint_128x128.e48b96f9.webp";